// components/invoices/utils/formatters.js

// Helper to format Firestore Timestamps into a readable date string
export const formatDate = (timestamp) => {
  if (!timestamp || !timestamp.toDate) {
    return '---';
  }
  return timestamp.toDate().toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

// Helper to format numbers into a currency string
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  }).format(amount || 0);
};